import React from 'react';

export function SiniestKpiCard({ label, value, sub, color, icon: Icon, testId }) {
  return (
    <div
      className="rounded-xl p-4 flex flex-col gap-2"
      style={{ background: 'var(--vz-bg-card)', border: '1px solid var(--vz-border-subtle)', boxShadow: 'var(--vz-shadow-card)' }}
      data-testid={testId}
    >
      <div className="flex items-center justify-between">
        <p className="text-[10px] font-montserrat font-semibold uppercase tracking-wider" style={{ color: 'var(--vz-text-muted)' }}>{label}</p>
        {Icon && (
          <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: `${color}18` }}>
            <Icon size={14} style={{ color }} />
          </div>
        )}
      </div>
      <p className="font-montserrat font-bold text-2xl" style={{ color: 'var(--vz-text-primary)' }}>{value}</p>
      {sub && <p className="text-[10px]" style={{ color: 'var(--vz-text-muted)' }}>{sub}</p>}
    </div>
  );
}
